module.exports = __webpack_public_path__ + "static/media/kola.dfcd3b56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/kola.jpg
// module id = 205
// module chunks = 0